import React from 'react';

import _ from 'lodash';
import classnames from 'classnames';

import styles from './styles.module.scss';

const renderInputField = ({
  id,
  input,
  type,
  placeholder,
  formErrors,
  disabled,
  dataTest,
  className,
  wrapperClassname,
  errorsClassname,
  meta: { touched, error, warning },
  autoFocus = false,
  isGeneric = true,
  autoComplete
}) => {
  const fieldErrors = _.get(formErrors, input.name);
  return (
    <div className={wrapperClassname}>
      <input
        id={id}
        className={classnames(
          { 'form-control': isGeneric },
          { 'not-valid': error & touched },
          { [styles.formControl]: isGeneric },
          { [styles.notValid]: error & touched },
          { [styles.disabled]: disabled },
          className
        )}
        data-test={dataTest}
        type={type}
        placeholder={placeholder}
        disabled={disabled}
        autoFocus={autoFocus}
        autoComplete={autoComplete}
        {...input}
      />
      {touched &&
        ((error && (
          <span
            className={classnames(
              'invalid-feedback',
              styles.invalidFeedback,
              errorsClassname
            )}>
            {error}
          </span>
        )) ||
          (warning && <span>{warning}</span>))}
      {touched &&
        (fieldErrors &&
          fieldErrors.map((error, index) => (
            <span
              className={classnames('invalid-feedback', styles.invalidFeedback)}
              key={index}>
              {error}
            </span>
          )))}
    </div>
  );
};

export default renderInputField;
